import { IconDefinition } from '@fortawesome/angular-fontawesome';
import { faCreativeCommons, faCreativeCommonsBy, faCreativeCommonsNc, faCreativeCommonsNd, faCreativeCommonsSa } from '@fortawesome/free-brands-svg-icons';

export const Licences: Record<number, { icons: IconDefinition[], link: string }> = {
    1: {
        icons: [ faCreativeCommons, faCreativeCommonsBy ],
        link: 'https://creativecommons.org/licenses/by/4.0/'
    },
    2: {
        icons: [ faCreativeCommons, faCreativeCommonsBy, faCreativeCommonsSa ],
        link: 'https://creativecommons.org/licenses/by-sa/3.0/'
    },
    3: {
        icons: [ faCreativeCommons, faCreativeCommonsBy, faCreativeCommonsNd ],
        link: 'https://creativecommons.org/licenses/by-nd/3.0/'
    },
    4: {
        icons: [ faCreativeCommons, faCreativeCommonsBy, faCreativeCommonsNc ],
        link: 'https://creativecommons.org/licenses/by-nc/3.0/'
    },
    5: {
        icons: [ faCreativeCommons, faCreativeCommonsBy, faCreativeCommonsNc, faCreativeCommonsSa ],
        link: 'https://creativecommons.org/licenses/by-nc-sa/3.0/'
    },
    6: {
        icons: [ faCreativeCommons, faCreativeCommonsBy, faCreativeCommonsNc, faCreativeCommonsNd ],
        link: 'https://creativecommons.org/licenses/by-nc-nd/3.0/'
    }
}
